<template>
  <global-dialog-card v-model="dialog" :title="$t('order_details')">
    <div v-if="showOrderDetails?.name">
      <p class="order-details-title">
        {{
          $t(changeDay(showOrderDetails.name.split(" ")[0])) +
          " " +
          showOrderDetails.name.split(" ")[1] +
          "."
        }}
      </p>
      <template v-for="shift in shifts">
        <v-col class="pa-0" cols="12" v-if="company[shift.key]" :key="shift.key">
          <p
            class="text-center font-weight-bold text-h6 my-2 order-details-shift-label"
            v-if="showTitle(shift.key, shift.label)"
          >
            {{ $t(shift.tKey) }}
          </p>
          <order-details-food-card
            v-for="meals in showOrderDetails[shift.key]"
            :key="meals.id || meals.name"
            :meals="meals"
            :shift="shift"
            :reserve-more="reserveMore"
          />
        </v-col>
      </template>
      <!-- Alert if no orders -->
      <v-col class="pa-0 title" cols="12" v-if="isEmptyOrder">
        <v-alert color="primary" text>
          <span>***</span>
          <span class="black--text"> Nema narudzbi za izabrani dan </span>
        </v-alert>
      </v-col>
    </div>

    <template #actions>
      <primary-button @click="dialog = false" :disabled="isEmptyOrder">
        {{ $t("confirm") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import OrderDetailsFoodCard from "@/components/dialogs/OrderDetailsFoodCard.vue";
import { changeDay } from "@/utils/dayShiftUtil";
export default {
  name: "OrderDetailsDialog",
  components: { OrderDetailsFoodCard },
  computed: {
    ...mapState("companyMenu", [
      "dialogs",
      "showOrderDetails",
      "selectedMeal",
      "selectedItem",
      "selectedDate",
    ]),
    dialog: {
      get() {
        return this.dialogs.orderDetails;
      },
      set(val) {
        this.setDialog({ dialog: "orderDetails", value: val });
      },
    },
    user() {
      return this.$store.state.user.user;
    },
    company() {
      return this.$store.state.company;
    },
    shifts() {
      return [
        { key: "shift_one", label: "1-smena", tKey: "shift_one" },
        { key: "shift_two", label: "2-smena", tKey: "shift_two" },
        { key: "shift_three", label: "3-smena", tKey: "shift_three" },
      ];
    },
    isEmptyOrder() {
      const sum = (shiftKey, label) =>
        (this.showOrderDetails?.[shiftKey] || []).reduce(
          (sum, meals) =>
            sum +
            (meals.orders || []).reduce(
              (sum2, meal) => sum2 + (meal.shift == label ? meal.quantity : 0),
              0
            ),
          0
        );
      return (
        sum("shift_one", "1-smena") +
          sum("shift_two", "2-smena") +
          sum("shift_three", "3-smena") ===
        0
      );
    },
  },
  methods: {
    ...mapMutations("companyMenu", ["setDialog"]),
    changeDay,
    showTitle(shiftKey, label) {
      return this.showOrderDetails?.[shiftKey]?.some((meals) =>
        (meals.orders || []).some((meal) => meal.shift == label && meal.quantity > 0)
      );
    },
    reserveMore(val, meal, meals, shiftLabel) {
      // You can implement this or connect to store action if needed
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.otkazi_por {
  padding: 13px 0;
  width: 100%;
  border: 2px solid $primary-color;
  border-radius: 12px;
  color: $primary-color;
  font-size: 16px;
  font-family: "Poppins", Helvetica, sans-serif !important;
}

.order-details-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 10px;
}

.order-details-title {
  font-size: 20px;
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-weight: 700;
  color: #2c2c2c;
}

.order-details-shift-label {
  background: rgb(255, 251, 249);
  padding: 8px 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}

.order-details-img {
  border-radius: 12px;
}

.order-details-meal-name {
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-weight: 700;
  color: #2c2c2c;
  font-size: 16px;
  line-height: 20px;
}

.order-details-food-name {
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;
}

.order-details-qty-box {
  width: 140px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 5px;
  border-radius: 12px;
}
</style>
